import React from "react";
import { useFetch } from "@/hooks/useApi";
import { API } from "@/lib/api";
import { PageHeader, Loader, StatusPill, Plate, EmptyState } from "@/components/common";
import { Card } from "@/components/ui/card";
import { gbp, ukDate } from "@/lib/format";

export default function DriverTickets() {
  const { data: tickets, loading } = useFetch("/tickets");
  if (loading) return <Loader />;
  const totalDeducted = (tickets || []).filter((t) => t.deduct_from_earnings).reduce((a, t) => a + t.amount, 0);

  return (
    <div className="fp-fade-in max-w-2xl mx-auto">
      <PageHeader title="My Tickets" subtitle="Fines and any deductions from your earnings" testId="driver-tickets-page" />
      <Card className="p-5 mb-6">
        <p className="text-xs uppercase tracking-wider text-muted-foreground">Total Deducted from Earnings</p>
        <p className="font-mono text-2xl font-bold mt-1 text-rose-400">{gbp(totalDeducted)}</p>
      </Card>
      <div className="space-y-3">
        {(tickets || []).length === 0 && <EmptyState icon="Receipt" title="No tickets" subtitle="Great driving!" />}
        {(tickets || []).map((t) => (
          <Card key={t.id} className="p-4" data-testid={`my-ticket-${t.id}`}>
            <div className="flex items-center justify-between">
              <div>
                <p className="font-medium">{t.type}</p>
                <div className="flex items-center gap-2 mt-1">
                  {t.van_reg && <Plate reg={t.van_reg} />}
                  <span className="text-xs text-muted-foreground">{ukDate(t.date)} · {t.reference}</span>
                </div>
              </div>
              <div className="text-right">
                <p className="font-mono font-bold text-rose-400">{gbp(t.amount)}</p>
                <div className="flex items-center gap-1.5 justify-end mt-1">
                  <StatusPill status={t.status} />
                  {t.deduct_from_earnings && <span className="text-[10px] text-rose-400 font-medium">deducted</span>}
                </div>
              </div>
            </div>
            {t.location && <p className="text-xs text-muted-foreground mt-2">{t.location}</p>}
            {t.evidence_file_id && <a href={`${API}/files/${t.evidence_file_id}`} target="_blank" rel="noreferrer" className="text-primary text-sm hover:underline mt-2 inline-block">View evidence</a>}
          </Card>
        ))}
      </div>
    </div>
  );
}
